import React from 'react';
import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';

interface IProps {
  messageId: string | null;
  originatingCountry: string | null;
  messageType: string | null;
  status: string | null;
  date_from: Date | null;
  date_to: Date | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  const Header = () => {
    return (
      <div className={classes.filter_header} style={{ marginTop: '0.5rem' }}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  const Body = () => {
    return (
      <FilterForm
        messageId={props.messageId}
        originatingCountry={props.originatingCountry}
        messageType={props.messageType}
        status={props.status}
        date_from={props.date_from}
        date_to={props.date_to}
      />
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      {/* <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => <Body />}
      /> */}
      {/* <Header /> */}
      <Body />
    </div>
  );
};

export default Filter;
